import { iconUri } from '@nerdwallet/nw-client-lib/cdn';

export default [
  {
    imgSrc:
      'https://www.nerdwallet.com/assets/blog/wp-content/uploads/2015/09/GettyImages-1217584509-2119x1414.jpg',
    imgAlt: 'Smiling woman sitting on a couch, checking a laptop',
    title: 'Get more help choosing between renting and buying',
    subtitle:
      'If you have a steady income, a good credit score, manageable debt and some money in savings and you want to put down some roots, you may be ready to buy a house.',
    description:
      'With a decision this big, you’ll want support. Here it is, including costs, down payments, pre-purchase preparation and how to tell if you’d be better off renting.',
    impressionTrackingId: 'rvb-related-articles-how-to',
    link: '/blog/mortgages/how-to-decide-whether-to-buy-a-home',
  },
  {
    imgSrc: iconUri('House_4'),
    imgAlt: 'House',
    title: "The home buyer's reality check",
    description:
      'Shopping for a home and shopping for a mortgage are two complex — and completely different — worlds.',
    impressionTrackingId: 'rvb-related-articles-reality-check',
    link: '/blog/mortgages/2017-home-buyer-reality-report',
  },
  {
    imgSrc: iconUri('Scale'),
    imgAlt: 'Old weighing scale',
    title: 'How much home can you afford?',
    description:
      'How to keep from getting into hot water with your home purchase.',
    impressionTrackingId: 'rvb-related-articles-how-much-house',
    link: '/blog/mortgages/house-afford',
  },
  {
    imgSrc: iconUri('Calculator'),
    imgAlt: 'Calculator',
    title: 'Calculate a comfortable monthly payment',
    description:
      'There’s what you’d like to spend, and what’s actually affordable. Run your own numbers and decide.',
    impressionTrackingId: 'rvb-related-articles-hac',
    link: '/mortgages/how-much-house-can-i-afford',
  },
];
